module.exports = __webpack_public_path__ + "img/background.4fd29fe7.png";